import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./pages/landing/landing.component').then((m) => m.LandingComponent) },
  { path: 'qualified', loadComponent: () => import('./pages/qualified/qualified.component').then((m) => m.QualifiedComponent) },
  { path: 'disqualified', loadComponent: () => import('./pages/disqualified/disqualified.component').then((m) => m.DisqualifiedComponent) },
  { path: 'error', loadComponent: () => import('./pages/error/error.component').then((m) => m.ErrorComponent) },
  { path: '**', redirectTo: '' },
];
